import "./ProyectosCommon.css";
import { MacroProyectoResponse } from "../../../shared/response/proyectos/MacroProyectoResponse";
import { MacroProyectoService } from "../../services/proyectos/MacroProyectoService";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";
import { fmtPct, fmtFechaProy } from "../../../shared/utils/proyectosFormat";

/**
 * Resumen de solo lectura del IPC congelado por Macro-Proyecto -pestaña "Macro-Proyectos" de
 * PM_Parametros.html-. El CRUD completo (crear/editar/activar) vive en su propia página
 * (/proyectos/macro-proyectos); esta pestaña solo explica, en el contexto de Parámetros, qué IPC
 * quedó (o no) congelado en cada uno.
 */
export class MacroProyectosParametrosPanel {
  private _tbody!: HTMLTableSectionElement;

  public render(container: HTMLElement): void {
    container.innerHTML = `
      <div class="pr-pg-hd">
        <div>
          <div class="pr-pg-ti">IPC congelado por Macro-Proyecto</div>
          <div class="pr-pg-su">Cuando un Macro-Proyecto se activa, el IPC vigente de su cosecha queda bloqueado para todos sus proyectos.</div>
        </div>
        <button class="sx-btn sx-btn-secondary sx-btn-sm" id="mpp-ver-todos">Ver Macro-Proyectos <i class="ph ph-arrow-right"></i></button>
      </div>

      <div class="pr-tbl-wrap">
        <table class="pr-tbl">
          <thead>
            <tr><th>Macro-Proyecto</th><th>Temporada</th><th>IPC aplicado</th><th>Congelado</th><th>Proyectos</th><th>Estado</th></tr>
          </thead>
          <tbody id="mpp-tbody"><tr><td colspan="6" class="pr-empty">Cargando…</td></tr></tbody>
        </table>
      </div>

      <div class="pr-alert-warn" style="margin-top:14px">
        El IPC solo se congela al <strong>activar</strong> el Macro-Proyecto. Mientras esté en configuración, los
        cambios de Parámetros aplican a los proyectos que se creen bajo ese macro. Una vez congelado, ningún cambio
        posterior afecta a los proyectos existentes.
      </div>
    `;

    this._tbody = container.querySelector("#mpp-tbody")! as HTMLTableSectionElement;
    container.querySelector<HTMLButtonElement>("#mpp-ver-todos")!.onclick = () =>
      document.dispatchEvent(new CustomEvent("app:navigate", { detail: "/proyectos/macro-proyectos" }));
    void this._loadData();
  }

  private async _loadData(): Promise<void> {
    try {
      const items = (await MacroProyectoService.instance.get())
        .filter((m) => !m.isEliminado)
        .sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._renderRows(items);
    } catch (error) {
      errorMessageComponent.addError("Error al cargar macro-proyectos", (error as Error).message);
      this._tbody.innerHTML = `<tr><td colspan="6" class="pr-empty">Error al cargar</td></tr>`;
    }
  }

  private _renderRows(items: MacroProyectoResponse[]): void {
    if (items.length === 0) {
      this._tbody.innerHTML = `<tr><td colspan="6" class="pr-empty">Sin macro-proyectos todavía.</td></tr>`;
      return;
    }
    this._tbody.innerHTML = items.map((m) => `
      <tr>
        <td style="font-weight:var(--sx-weight-semibold)">${this._esc(m.nombre)}</td>
        <td>${this._esc(m.cosechaNombre)}</td>
        <td class="pr-num">${m.cosechaFrozen ? fmtPct(m.cosechaTasaBaseIpc) + " base" : "<span style='color:var(--sx-text-tertiary)'>—</span>"}</td>
        <td style="font-size:var(--sx-text-xs);color:var(--sx-text-tertiary)">${m.fechaActivacion ? fmtFechaProy(m.fechaActivacion) : "Sin congelar"}</td>
        <td class="pr-num">${m.totalProyectos}</td>
        <td>${m.cosechaFrozen
          ? `<span class="pr-pill na"><i class="ph ph-lock-simple"></i> Congelado</span>`
          : `<span class="pr-pill borrador">En configuración</span>`}
        </td>
      </tr>`).join("");
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
